var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("box", { attrs: { hideable: true } }, [
    _c("h3", { attrs: { slot: "header" }, slot: "header" }, [
      _c("i", { staticClass: "fas fa-tasks" }),
      _vm._v(
        " " +
          _vm._s(_vm.resource("AnalysisSelection_Index_Queue_Header")) +
          "\n    "
      )
    ]),
    _vm._v(" "),
    _c("div", { attrs: { slot: "body" }, slot: "body" }, [
      _c("div", { staticClass: "grid-container queue" }, [
        _c(
          "div",
          [
            _c("queue-buttons", {
              attrs: {
                loading: _vm.loading,
                totalTime: _vm.totalTime(),
                selectedTime: _vm.selectedTime()
              },
              on: {
                "get-queue": _vm.getQueue,
                "clear-queue": _vm.clearQueue,
                "start-analysis": _vm.startAnalysis
              }
            })
          ],
          1
        ),
        _vm._v(" "),
        _c(
          "div",
          [
            _c("data-table", {
              staticClass: "table table-striped",
              attrs: {
                loading: _vm.loading,
                data: _vm.value,
                columns: _vm.columns,
                datatableOptions: _vm.datatableOptions,
                options: _vm.options
              },
              on: {
                selected: function($event) {
                  return _vm.addCall($event)
                },
                unselected: function($event) {
                  return _vm.removeCall($event)
                },
                "select-all": function($event) {
                  return _vm.selectAll($event)
                },
                "unselect-all": function($event) {
                  return _vm.unselectAll($event)
                }
              }
            })
          ],
          1
        ),
        _vm._v(" "),
        _c(
          "div",
          [
            _c("queue-buttons", {
              attrs: {
                loading: _vm.loading,
                totalTime: _vm.totalTime(),
                selectedTime: _vm.selectedTime()
              },
              on: {
                "get-queue": _vm.getQueue,
                "clear-queue": _vm.clearQueue,
                "start-analysis": _vm.startAnalysis
              }
            })
          ],
          1
        )
      ])
    ])
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }